/** 404 page, in Poroboard's look: the bar's home and name, then the message with the way back. */
import { AppBar, BrandTitle, HomeButton, LOOK, PoroIcon, PrimaryLink } from '@play/ui';
import { Swords } from 'lucide-react';
import { RUNEBOUND_URL } from '../components/site';

/** Shown for unknown routes. */
export function NotFound() {
  return (
    <div className="min-h-dvh flex flex-col" style={{ background: LOOK.page, color: LOOK.text }}>
      <AppBar
        start={
          <>
            <HomeButton href={RUNEBOUND_URL} label="Runebound home" />
            <a href="/" aria-label="Runebound Play home">
              <BrandTitle icon={<Swords size={15} />} lead="Runebound " holo="Play" />
            </a>
          </>
        }
      />
      <main className="flex-1 flex flex-col items-center justify-center gap-3 text-center p-6 pb-24">
        <span
          className="w-14 h-14 rounded-[14px] inline-flex items-center justify-center mb-2"
          style={{ background: 'rgba(124,92,255,0.14)', color: '#b9adff' }}
        >
          <PoroIcon size={30} />
        </span>
        <h1 className="font-display text-[30px] leading-9 font-bold">Nothing here</h1>
        <p className="text-[14px]" style={{ color: LOOK.sub }}>
          This link doesn’t lead to a table.
        </p>
        <PrimaryLink big href="/play" className="mt-4">
          Go to Play
        </PrimaryLink>
      </main>
    </div>
  );
}
